module.exports = __webpack_public_path__ + "img/coordinamos.6b68ab5f.png";